import { CategoryKey, OptionType } from '@aibees/shared/features';

const PROFILE_INSIGHT_CATEGORIES: string[] = [
  CategoryKey.companyLocations,
  CategoryKey.experiences,
  CategoryKey.educations,
  CategoryKey.awards,
  CategoryKey.courses,
  CategoryKey.projects,
  CategoryKey.languages,
  CategoryKey.certifications,
  CategoryKey.volunteerExperiences,
  CategoryKey.publications,
  CategoryKey.patents,
];

const PROFILE_INSIGHT_FIELDS: string[] = [
  OptionType.HEADLINE,
  OptionType.SUMMARY,
  OptionType.SKILLS,
  OptionType.INFLUENCER,
  OptionType.OPEN_TO_WORK,
  OptionType.PREMIUM,
  OptionType.CREATOR,
  OptionType.DATE_OF_BIRTH,
  OptionType.JOB_COUNT,
  OptionType.PROFILE_PICTURE,
];

export function hasProfileInsightFields(
  exportSetting?: Record<string, any>
): boolean {
  if (!exportSetting) return false;

  for (const key in exportSetting) {
    const item = exportSetting[key];

    if (PROFILE_INSIGHT_CATEGORIES.includes(key)) {
      if (Array.isArray(item)) {
        if (item.some((entry) => entry.fields?.length > 0)) return true;
      } else if (item?.fields?.length > 0) {
        return true;
      }
    } else {
      if (Array.isArray(item)) {
        if (
          item.some((entry) =>
            entry.fields?.some((f: string) =>
              PROFILE_INSIGHT_FIELDS.includes(f)
            )
          )
        )
          return true;
      } else if (
        item?.fields?.some((f: string) => PROFILE_INSIGHT_FIELDS.includes(f))
      ) {
        return true;
      }
    }
  }
  return false;
}
